import { gql } from '@apollo/client';

export const UPDATE_LOCATION_HEALTH_SUMMARY = gql`
  mutation ($input: UpdateHealthSummaryDto!) {
    updateLocationHealthSummary(input: $input)
  }
`;
